module.exports = __webpack_public_path__ + "static/media/circleCross2.1ac81576.svg";